import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Tooltip from 'material-ui/Tooltip';

const styles = () => ({
  star: {
    color: '#D8DBDF',
    fontSize: '1em',
    position: 'relative',
  },

  full: {
    '&:before': {
      color: '#1A65FF',
      content: '\'\\2605\'',
      position: 'absolute',
      left: 0,
    },
  },

  half: {
    '&:before': {
      color: '#1A65FF',
      content: '\'\\2605\'',
      position: 'absolute',
      left: 0,
      width: '50%',
      overflow: 'hidden',
    },
  },

  arrowArrow: {
    position: 'absolute',
    fontSize: 7,
    bottom: 0,
    left: '50%',
    marginBottom: '-1em',
    width: '3em',
    height: '1em',
    transform: 'translateX(-50%)',

    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#181819 transparent transparent transparent`,
    },
  },

  tooltip: {
    fontSize: '13px',
    background: '#181819',
    boxShadow: '0 3px 6px rgba(0,0,0,.12)',
    padding: '5px 10px'
  },
});

const defaultStylesCount = 3;
const half = 0.5;
const firstIndex = 0;
const secondIndex = 1;
const thirdIndex = 2;
class Rating extends React.Component {
  state = {
    arrowRef: null,
    styles: new Array(defaultStylesCount),
  };

  componentWillMount() {
    this.updateStyles(this.props.rating);
  }

  componentWillReceiveProps(nextProps) {
    this.updateStyles(nextProps.rating);
  }

  updateStyles = (rating) => {
    const { classes } = this.props;

    let styles = new Array(defaultStylesCount);

    for (let i = 0; i < styles.length; i++) {
      if (rating - i > half) {
        styles[i] = classNames(classes.star, classes.full);
      } else if (rating - i === half) {
        styles[i] = classNames(classes.star, classes.half);
      } else {
        styles[i] = classNames(classes.star);
      }
    }

    this.setState({
      styles: styles,
    })
  }

  render() {
    const { classes, tooltip } = this.props;
    const { styles } = this.state;

    if (tooltip) {
      return (
        <Tooltip
          placement="top"
          title={
            <React.Fragment>
              {tooltip}
              <span className={classes.arrowArrow} />
            </React.Fragment>
          }
          classes={{ tooltip: classes.tooltip }}
        >
          <div>
            <span className={styles[firstIndex]}>★</span>
            <span className={styles[secondIndex]}>★</span>
            <span className={styles[thirdIndex]}>★</span>
          </div>
        </Tooltip>
      );
    } else {
      return (
        <div>
          <span className={styles[firstIndex]}>★</span>
          <span className={styles[secondIndex]}>★</span>
          <span className={styles[thirdIndex]}>★</span>
        </div>
      )
    }
  }
}

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
  tooltip: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

Rating.defaultProps = {
  rating: 0
};

export default withStyles(styles)(Rating);



// WEBPACK FOOTER //
// ./src/components/common/Rating.jsx